import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeaturesBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { DefaultBlock as Block } from "./DefaultBlock";
import { defaultData } from "./DefaultBlockDefaultData";
import { defaultStyles } from "./defaultStyles";

export const DefaultBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  meta: {
    name: "Default block",
    nameI18n:
      "settings.emails.visual_builder.block_type.feature_block.default_block",
    version: 1,
    category: [FeaturesBlock],
    isHidden: true,
    props: {
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: defaultStyles.backgroundColor,
            type: "color-without-alpha",
            nameI18n:
              "settings.emails.visual_builder.prop_type.styles.background_color",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: defaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: defaultStyles.margin,
          },
        },
      },
    },
  },
};
